import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import { RouteTracker } from './components/RouteTracker'
import Homepage from './pages/Homepage'
import Login from './pages/Login'
import Register from './pages/Register'
import Leaderboard from './pages/Leaderboard'
import WakeUp from './pages/WakeUp'
import Profile from './pages/Profile'
import Timetable from './pages/Timetable'
import Communities from './pages/Communities'
import DiscoverCommunities from './pages/DiscoverCommunities'
import JoinCommunity from './pages/JoinCommunity'
import CommunityWakeUp from './pages/CommunityWakeUp'
import CommunityMembers from './pages/CommunityMembers'
import VerifyOTP from './pages/VerifyOTP'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsAndConditions from './pages/TermsAndConditions'
import UserGuide from './pages/UserGuide'
import ForgotPassword from './pages/ForgotPassword'
import CompleteProfile from './pages/CompleteProfile'
import GoogleAuthSuccess from './pages/GoogleAuthSuccess'
import DeleteAccountGuide from './pages/DeleteAccount'

function App() {
  return (
    <AuthProvider>
      <Router>
        <RouteTracker />
        <Routes>
          <Route 
            path="/" 
            element={
              <ProtectedRoute requiredAuth={false}>
                <Homepage />
              </ProtectedRoute>
            } 
          />
          <Route
            path="/login"
            element={<Login />}
          />
          <Route
            path="/register"
            element={<Register />}
          />
          <Route
            path="/forgot-password"
            element={<ForgotPassword />}
          />
          <Route
            path="/auth/google-success"
            element={<GoogleAuthSuccess />}
          />
          <Route
            path="/auth/complete-profile"
            element={<CompleteProfile />}
          />
          <Route 
            path="/leaderboard" 
            element={
              <ProtectedRoute>
                <Leaderboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/wake-up" 
            element={
              <ProtectedRoute>
                <WakeUp />
              </ProtectedRoute>
            } 
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/timetable"
            element={
              <ProtectedRoute requiredAuth={false}>
                <Timetable />
              </ProtectedRoute>
            }
          />
          <Route
            path="/communities"
            element={
              <ProtectedRoute>
                <Communities />
              </ProtectedRoute>
            }
          />
          <Route
            path="/communities/discover"
            element={
              <ProtectedRoute>
                <DiscoverCommunities />
              </ProtectedRoute>
            }
          />
          <Route
            path="/communities/join/:inviteCode"
            element={
              <ProtectedRoute>
                <JoinCommunity />
              </ProtectedRoute>
            }
          />
          <Route
            path="/community-wake-up" 
            element={
              <ProtectedRoute>
                <CommunityWakeUp />
              </ProtectedRoute>
            } 
          />
          <Route
            path="/communities/:communityId/members"
            element={
              <ProtectedRoute>
                <CommunityMembers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/verify-otp"
            element={
              <ProtectedRoute>
                <VerifyOTP />
              </ProtectedRoute>
            }
          />
          <Route
            path="/privacy-policy"
            element={<PrivacyPolicy />}
          />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route
            path="/user-guide"
            element={<UserGuide />}
          />
          <Route
            path="/delete-account"
            element={<DeleteAccountGuide />}
          />
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App
